
document.addEventListener('DOMContentLoaded', () => {
    "use strict";

    const inputTypeClasses = {
    text: "input-text-wrapper",
    search: "search-wrap",
    password: "input-password-wrapper",
    number: "input-number-wrapper",
    date: "input-date-wrapper",
    file: "input-file-wrapper", // <-- додано для file
    textarea: "textarea-wrapper", // Клас для textarea
    month: "input-date-wrapper"
    // Додайте інші типи за необхідності
};

// Функція для створення обгортки для інпутів і textarea
function wrapInput(input) {
    const tagName = input.tagName.toLowerCase(); // Визначаємо тег (input чи textarea)
    const type = input.type; // Для input беремо type

    const wrapper = document.createElement('div');
    wrapper.className = 'input-mask-wrap';

    // Додаємо додатковий клас залежно від типу або тега
    if (tagName === 'textarea') {
        wrapper.classList.add(inputTypeClasses.textarea); // Для textarea
    } else if (inputTypeClasses[type]) {
        wrapper.classList.add(inputTypeClasses[type]); // Для input
    }

    // Переносимо елемент в обгортку
    input.parentElement.insertBefore(wrapper, input);
    wrapper.appendChild(input);

    // Додаємо placeholder-mask, якщо є placeholder (крім file)
    const placeholder = input.getAttribute('placeholder');
    if (placeholder && type !== "file") {
        const span = document.createElement('span');
        span.className = 'placeholder-mask';
        span.textContent = placeholder;
        wrapper.appendChild(span);
    }

    // ===========================================================================
    function updateStatus() {
        const focusState = document.activeElement === input ? 'focus' : 'blur';
        const valueState = input.value.trim() === '' ? 'empty' : 'filled';
        wrapper.setAttribute('data-status', `${focusState} ${valueState}`);
    }

    input.addEventListener('focus', updateStatus);
    input.addEventListener('blur', updateStatus);
    input.addEventListener('input', updateStatus);

    // Ініціалізація
    updateStatus();

    return wrapper;
}

// ===========================================================================
// TYPE TEL (tel-mask)
// ===========================================================================
const TEL_MASK_PREFIX = '+380 ';
const TEL_MASK_GROUPS = [2, 3, 2, 2];
const TEL_MASK_MAX_DIGITS = 9;
const TEL_MASK_REGEX = /^\+380 \d{2} \d{3} \d{2} \d{2}$/;

function extractTelDigits(value) {
    let digits = value.replace(/\D/g, '');

    if (digits.startsWith('380')) {
        digits = digits.slice(3);
    } else if (digits.startsWith('0') && digits.length === 10) {
        digits = digits.slice(1);
    }

    return digits.slice(0, TEL_MASK_MAX_DIGITS);
}

function formatTelValue(digits) {
    let index = 0;
    const parts = [];

    for (const group of TEL_MASK_GROUPS) {
        if (index >= digits.length) break;
        parts.push(digits.slice(index, index + group));
        index += group;
    }

    return `${TEL_MASK_PREFIX}${parts.join(' ')}`.trim();
}

function applyTelMask(input) {
    const digits = extractTelDigits(input.value);

    if (digits.length === 0) {
        input.value = document.activeElement === input ? TEL_MASK_PREFIX : '';
        return;
    }

    input.value = formatTelValue(digits);
}

function ensureTelValidationRule(input) {
    if (!window.jQuery || input.dataset.telMaskValidation === '1') return;

    const $input = window.jQuery(input);
    const $form = $input.closest('form');
    if (!$form.length || !$form.data('validator')) return;

    $input.rules('add', { regex: TEL_MASK_REGEX });
    input.dataset.telMaskValidation = '1';
}

function initFileAvatarInput(fileInput, form) {
    const wrapper = fileInput.parentElement;
    const inputItem = fileInput.closest('.input-item');
    if (!wrapper || !inputItem) return;

    wrapper.classList.add('input-file-wrapper');

    let preview = wrapper.querySelector('.file-avatar__preview');
    if (!preview) {
        preview = document.createElement('div');
        preview.className = 'file-avatar__preview';
        preview.setAttribute('aria-hidden', 'true');
        wrapper.insertBefore(preview, fileInput);
    }

    const clearPreview = () => {
        preview.style.backgroundImage = '';
        preview.style.backgroundSize = '';
        preview.style.backgroundPosition = '';
        inputItem.classList.remove('file-avatar--has-image');
    };

    const applyImageFile = (file) => {
        if (!file || !file.type.startsWith('image/')) {
            clearPreview();
            return;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
            preview.style.backgroundImage = `url("${e.target.result}")`;
            preview.style.backgroundSize = 'cover';
            preview.style.backgroundPosition = 'center center';
            inputItem.classList.add('file-avatar--has-image');
        };
        reader.onerror = () => clearPreview();
        reader.readAsDataURL(file);
    };

    fileInput.addEventListener('change', () => {
        const file = fileInput.files && fileInput.files[0];
        applyImageFile(file);
    });

    form.addEventListener('reset', () => {
        setTimeout(() => {
            clearPreview();
        }, 0);
    });
}

function initTelMask(form) {
    const telInputs = form.querySelectorAll('.input-item.tel-mask input[type="tel"], .input-item.tel-mask input[type="text"]');
    if (!telInputs.length) return;

    telInputs.forEach(input => {
        if (input.dataset.telMaskInit === '1') return;
        input.dataset.telMaskInit = '1';

        input.setAttribute('inputmode', 'numeric');
        input.setAttribute('autocomplete', 'tel');
        input.setAttribute('data-rule-regex', TEL_MASK_REGEX.source);

        const setCaretToEnd = () => {
            const pos = input.value.length;
            input.setSelectionRange(pos, pos);
        };

        input.addEventListener('focus', () => {
            if (!input.value) {
                input.value = TEL_MASK_PREFIX;
            }
            applyTelMask(input);
            setCaretToEnd();
            ensureTelValidationRule(input);
        });

        input.addEventListener('blur', () => {
            const digits = extractTelDigits(input.value);
            if (digits.length === 0) {
                input.value = '';
            } else {
                input.value = formatTelValue(digits);
            }
            ensureTelValidationRule(input);
        });

        input.addEventListener('keydown', (event) => {
            const caretStart = input.selectionStart || 0;
            const caretEnd = input.selectionEnd || 0;
            if (caretStart <= TEL_MASK_PREFIX.length && caretEnd <= TEL_MASK_PREFIX.length) {
                if (event.key === 'Backspace' || event.key === 'Delete') {
                    event.preventDefault();
                    setCaretToEnd();
                }
            }
        });

        input.addEventListener('input', () => {
            applyTelMask(input);
            setCaretToEnd();
            ensureTelValidationRule(input);
        });

        // Ініціалізація значення
        applyTelMask(input);
    });
}

// Отримуємо всі форми на сторінці
const forms = document.querySelectorAll('form.form-theme');

forms.forEach(form => {
    // Обгортання всіх інпутів і textarea
    const inputsAndTextareas = form.querySelectorAll('input:not([type=radio]):not([type=checkbox]), textarea');
    inputsAndTextareas.forEach(input => wrapInput(input));

    // Робота з select
    const selects = form.querySelectorAll('select');
    selects.forEach(select => {
        const wrapper = wrapInput(select);
        wrapper.classList.add('select-container');

        select.addEventListener('focus', () => {
            wrapper.classList.add('active');
        });

        select.addEventListener('blur', () => {
            setTimeout(() => {
                if (!select.matches(':focus')) {
                    wrapper.classList.remove('active');
                }
            }, 100);
        });

        select.addEventListener('change', () => {
            wrapper.classList.toggle('selected', !!select.value);
        });
    });

    // Робота з input[type="number"]
    const inputNumbers = form.querySelectorAll('input[type="number"]');
    inputNumbers.forEach(inputNumber => {
        const wrapper = inputNumber.parentElement;

        const up = document.createElement('div');
        up.className = 'up';
        up.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 0V16M0 8H16" stroke="black"/></svg>';

        const down = document.createElement('div');
        down.className = 'down';
        down.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 8H16" stroke="black"/></svg>';

        wrapper.appendChild(down);
        wrapper.appendChild(up);

        if (inputNumber.value === "") {
            inputNumber.value = 0;
        }

        up.addEventListener('click', function () {
            const step = parseFloat(inputNumber.getAttribute('step')) || 1;
            const max = parseFloat(inputNumber.getAttribute('max')) || Infinity;
            let value = parseFloat(inputNumber.value) || 0;
            value = Math.min(value + step, max);
            inputNumber.value = value;
            inputNumber.dispatchEvent(new Event('input', {bubbles: true}));
        });

        down.addEventListener('click', function () {
            const step = parseFloat(inputNumber.getAttribute('step')) || 1;
            const min = parseFloat(inputNumber.getAttribute('min')) || -Infinity;
            let value = parseFloat(inputNumber.value) || 0;
            value = Math.max(value - step, min);
            inputNumber.value = value;
            inputNumber.dispatchEvent(new Event('input', {bubbles: true}));
        });
    });

    // Робота з input[type="password"]
    const passwordInputs = form.querySelectorAll('input[type="password"]');
    passwordInputs.forEach(input => {
        const wrapper = input.parentElement;

        const toggleButton = document.createElement('div');
        toggleButton.className = 'vis-pass';
        toggleButton.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8s2.5-4 7-4 7 4 7 4-2.5 4-7 4-7-4-7-4z" stroke="black"/><circle cx="8" cy="8" r="2" stroke="black"/></svg>';

        wrapper.appendChild(toggleButton);

        toggleButton.addEventListener('click', function () {
            if (input.type === 'password') {
                input.type = 'text';
                toggleButton.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8s2.5-4 7-4 7 4 7 4-2.5 4-7 4-7-4-7-4z" stroke="black"/><path d="M2 2l12 12" stroke="black"/></svg>';
            } else {
                input.type = 'password';
                toggleButton.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8s2.5-4 7-4 7 4 7 4-2.5 4-7 4-7-4-7-4z" stroke="black"/><circle cx="8" cy="8" r="2" stroke="black"/></svg>';
            }
        });
    });

    // Робота з input[type="file"]
    const fileInputs = form.querySelectorAll('input[type="file"]');
    fileInputs.forEach(fileInput => {
        const inputItemForAvatar = fileInput.closest('.input-item');
        if (inputItemForAvatar && inputItemForAvatar.classList.contains('file-avatar')) {
            initFileAvatarInput(fileInput, form);
            return;
        }

        const wrapper = fileInput.parentElement;

        // про всяк випадок додамо клас-мітку
        wrapper.classList.add('input-file-wrapper');

        // створюємо/знаходимо span.file-name
        let fileLabel = wrapper.querySelector('.file-name');
        if (!fileLabel) {
            fileLabel = document.createElement('span');
            fileLabel.className = 'file-name';
            wrapper.appendChild(fileLabel);
        }

        // початковий текст беремо з placeholder інпута
        const placeholderText = fileInput.getAttribute('placeholder') || '';
        fileLabel.textContent = placeholderText;

        // допоміжна для відображення назви(ів) файлу
        const getFileText = () => {
            const { files } = fileInput;
            if (!files || files.length === 0) return placeholderText;
            if (files.length === 1) return files[0].name;
            return `${files.length} files selected`; // підтримка multiple
            // якщо треба всі назви: return Array.from(files).map(f => f.name).join(', ');
        };

        const updateLabel = () => {
            fileLabel.textContent = getFileText();
        };

        fileInput.addEventListener('change', updateLabel);

        // якщо очищають програмно (value = '')
        fileInput.addEventListener('input', () => {
            if (!fileInput.value) fileLabel.textContent = placeholderText;
        });

        // при скиданні форми повертаємо плейсхолдер
        form.addEventListener('reset', () => {
            setTimeout(() => {
                fileLabel.textContent = placeholderText;
            }, 0);
        });

        // ===========================================================================
        // Прев'ю зображень для input[type="file"]
        // ===========================================================================
        
        // Налаштування валідації (можна змінювати)
        const validationConfig = {
            maxFiles: 5,                    // Максимальна кількість файлів
            maxFileSize: 400 * 1024 * 1024, // Максимальний розмір файлу в байтах (400MB)
            allowedFormats: ['.jpg', '.jpeg', '.png', '.gif', '.webp'] // Дозволені формати
        };
        
        // Знаходимо батьківський input-item
        const inputItem = fileInput.closest('.input-item');
        
        if (inputItem) {
            // Перевіряємо, чи є блок images-previews
            let imagesPreviews = inputItem.querySelector('.images-previews');
            
            // Якщо блоку немає, створюємо його
            if (!imagesPreviews) {
                imagesPreviews = document.createElement('div');
                imagesPreviews.className = 'images-previews';
                // Вставляємо після wrapper (або після fileInput, якщо wrapper не input-item)
                if (inputItem === wrapper || wrapper.parentElement === inputItem) {
                    inputItem.appendChild(imagesPreviews);
                } else {
                    wrapper.parentElement.insertBefore(imagesPreviews, wrapper.nextSibling);
                }
            }

            // Створюємо/знаходимо список для прев'ю
            let imagesPreviewsList = imagesPreviews.querySelector('.images-previews__list');
            if (!imagesPreviewsList) {
                imagesPreviewsList = document.createElement('div');
                imagesPreviewsList.className = 'images-previews__list';
                imagesPreviews.appendChild(imagesPreviewsList);
            }

            // Створюємо/знаходимо контейнер для помилок
            let errorContainer = imagesPreviews.querySelector('.images-previews__error-text');
            if (!errorContainer) {
                errorContainer = document.createElement('div');
                errorContainer.className = 'images-previews__error-text';
                imagesPreviews.insertBefore(errorContainer, imagesPreviewsList);
            }

            // Функція для створення/знаходження елементів помилок (span всередині контейнера)
            const getOrCreateErrorElement = (errorClass) => {
                let errorElement = errorContainer.querySelector('.' + errorClass);
                if (!errorElement) {
                    errorElement = document.createElement('span');
                    errorElement.className = errorClass;
                    errorContainer.appendChild(errorElement);
                }
                return errorElement;
            };

            // Функція для приховування всіх помилок
            const hideAllErrors = () => {
                const errorElements = errorContainer.querySelectorAll('[class*="images-previews__error-text--"]');
                errorElements.forEach(error => error.classList.remove('active'));
            };

            // Функція для перевірки формату файлу
            const isValidFormat = (fileName) => {
                const fileExtension = fileName.toLowerCase().substring(fileName.lastIndexOf('.'));
                return validationConfig.allowedFormats.includes(fileExtension);
            };

            // Функція для показу тільки однієї помилки (прибирає active з інших)
            const showOnlyOneError = (activeErrorElement) => {
                const allErrorElements = errorContainer.querySelectorAll('[class*="images-previews__error-text--"]');
                allErrorElements.forEach(error => {
                    if (error !== activeErrorElement) {
                        error.classList.remove('active');
                    }
                });
            };

            // Функція для валідації файлів
            const validateFiles = (files) => {
                hideAllErrors();
                let hasErrors = false;
                let activeErrorElement = null;

                // Перевірка 1: Кількість файлів
                if (files.length > validationConfig.maxFiles) {
                    const errorElement = getOrCreateErrorElement('images-previews__error-text--max-files');
                    // Прибираємо active з попередньої помилки, якщо вона є
                    if (activeErrorElement) {
                        activeErrorElement.classList.remove('active');
                    }
                    errorElement.classList.add('active');
                    activeErrorElement = errorElement;
                    hasErrors = true;
                }

                // Перевірка 2: Розмір файлів
                const oversizedFiles = files.filter(file => file.size > validationConfig.maxFileSize);
                if (oversizedFiles.length > 0) {
                    const errorElement = getOrCreateErrorElement('images-previews__error-text--max-size');
                    // Прибираємо active з попередньої помилки, якщо вона є
                    if (activeErrorElement) {
                        activeErrorElement.classList.remove('active');
                    }
                    errorElement.classList.add('active');
                    activeErrorElement = errorElement;
                    hasErrors = true;
                }

                // Перевірка 3: Формат файлів
                const invalidFormatFiles = files.filter(file => !isValidFormat(file.name));
                if (invalidFormatFiles.length > 0) {
                    const errorElement = getOrCreateErrorElement('images-previews__error-text--files-type');
                    // Прибираємо active з попередньої помилки, якщо вона є
                    if (activeErrorElement) {
                        activeErrorElement.classList.remove('active');
                    }
                    errorElement.classList.add('active');
                    activeErrorElement = errorElement;
                    hasErrors = true;
                }

                // Забезпечуємо, що тільки одна помилка активна (додаткова перевірка)
                if (activeErrorElement) {
                    showOnlyOneError(activeErrorElement);
                }

                return !hasErrors;
            };

            // Функція для створення прев'ю зображення
            const createImagePreview = (file) => {
                const reader = new FileReader();
                
                reader.onload = function(e) {
                    // Створюємо елемент прев'ю
                    const previewItem = document.createElement('div');
                    previewItem.className = 'images-previews__item';
                    
                    // Створюємо контейнер для зображення
                    const imageContainer = document.createElement('div');
                    imageContainer.className = 'images-previews__image';
                    const img = document.createElement('img');
                    img.src = e.target.result;
                    img.alt = '';
                    imageContainer.appendChild(img);
                    
                    // Створюємо кнопку Remove
                    const removeButton = document.createElement('button');
                    removeButton.type = 'button';
                    removeButton.textContent = 'Remove';
                    
                    // Обробник для видалення прев'ю
                    removeButton.addEventListener('click', function() {
                        previewItem.remove();
                        
                        // Оновлюємо input - видаляємо файл зі списку
                        // Для multiple потрібно створити новий DataTransfer
                        if (fileInput.multiple) {
                            const dt = new DataTransfer();
                            const currentFiles = Array.from(fileInput.files);
                            const fileIndex = currentFiles.findIndex(f => f.name === file.name && f.size === file.size && f.lastModified === file.lastModified);
                            
                            if (fileIndex !== -1) {
                                currentFiles.splice(fileIndex, 1);
                                currentFiles.forEach(f => dt.items.add(f));
                                fileInput.files = dt.files;
                                fileInput.dispatchEvent(new Event('change', { bubbles: true }));
                            }
                        } else {
                            // Для single file просто очищаємо
                            fileInput.value = '';
                            fileInput.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    });
                    
                    // Додаємо елементи до прев'ю
                    previewItem.appendChild(imageContainer);
                    previewItem.appendChild(removeButton);
                    
                    // Додаємо прев'ю до списку
                    imagesPreviewsList.appendChild(previewItem);
                };
                
                reader.onerror = function() {
                    console.error('Помилка завантаження зображення:', file.name);
                };
                
                reader.readAsDataURL(file);
            };

            // Обробник зміни файлів
            fileInput.addEventListener('change', function() {
                const files = Array.from(fileInput.files);
                
                // Валідуємо файли
                const isValid = validateFiles(files);
                
                if (!isValid) {
                    // Якщо є помилки, очищаємо input та існуючі прев'ю
                    fileInput.value = '';
                    
                    // Очищаємо існуючі прев'ю
                    const existingPreviews = imagesPreviewsList.querySelectorAll('.images-previews__item');
                    existingPreviews.forEach(preview => preview.remove());
                    
                    // Оновлюємо label
                    fileLabel.textContent = placeholderText;
                    
                    return;
                }

                // Очищаємо існуючі прев'ю
                const existingPreviews = imagesPreviewsList.querySelectorAll('.images-previews__item');
                existingPreviews.forEach(preview => preview.remove());
                
                // Створюємо прев'ю для кожного зображення
                files.forEach(file => {
                    createImagePreview(file);
                });
            });

            // Очищаємо прев'ю та помилки при скиданні форми
            form.addEventListener('reset', () => {
                setTimeout(() => {
                    const existingPreviews = imagesPreviewsList.querySelectorAll('.images-previews__item');
                    existingPreviews.forEach(preview => preview.remove());
                    hideAllErrors();
                }, 0);
            });
        }
    });

    // Робота з input tel-mask
    initTelMask(form);

});

    // ADD IMAGES THEME
// ===========================================================

});




